import { type BaseDto, type Nullable } from "@pasta/box-v2";
import { type UserDto } from "@pasta/front-auth-v2";
import { type LetterFileDto } from "./letter-file.dto";

export enum LetterFileCommentType {
  TEXT = "text",
  AUDIO = "audio",
}

export interface LetterFileCommentAudioText {
  link: string;
  duration: number;
  size: number;
  currentTime?: Record<number, number>;
}

export interface LetterFileCommentDto extends BaseDto {
  text: string;
  letterFile: LetterFileDto;
  author: UserDto;
  frozen: boolean;
  target?: Nullable<{
    name: string;
    mail: string;
    firstName: string;
    lastName: string;
  }>;
  type: LetterFileCommentType;
}

export interface WriteLetterFileCommentDto {
  text: string;
  letterFile: number;
  target?: Nullable<string>;
  type?: LetterFileCommentType;
}
